import React, { useState } from 'react';
import { McgJazzLogo } from './McgJazzLogo';
import '../styles/AuthForm.css';

export const AuthForm = ({ onAuth, loading, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    if (!username.trim()) {
      setFormError('Username is required');
      return;
    }
    if (!password) {
      setFormError('Password is required');
      return;
    }

    try {
      await onAuth(username, password, false);
      setUsername('');
      setPassword('');
    } catch (err) {
      setFormError(err.message);
    }
  };

  return (
    <div className="AuthForm">
      <div className="AuthForm-container">
        <div className="AuthForm-logo">
          <McgJazzLogo size={56} color="#C8102E" />
        </div>
        <h1 className="AuthForm-title">MCG Jazz</h1>
        <p className="AuthForm-subtitle">Sign in to your account</p>

        <form onSubmit={handleSubmit} className="AuthForm-form">
          <div className="AuthForm-field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="AuthForm-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {(formError || error) && (
            <div className="AuthForm-error">
              {formError || error}
            </div>
          )}

          <button
            type="submit"
            className="AuthForm-button"
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};
